 import { TiTick } from "react-icons/ti";
import { useEffect, useRef, useState } from "react";
import { useMemo } from "react";


const servicesData = [
  { 
    title: "Content & Creative", 
    description1: "We don’t just create content, we craft stories that connect. From concept to execution, every piece is designed to spark emotion, inspire action, and build lasting brand loyalty.", 
    description2: "We partner with you to uncover new opportunities, eliminate roadblocks, and fine-tune your content strategy for maximum impact. Our creative team moves quickly and efficiently, ensuring your brand story is unforgettable.", 
    services: ["Social Media", "Blog Content", "Brand Design", "Video Production", "Email Marketing"],
    link: "/digital-marketing/services/content-creative"
  },
  { 
    title: "Paid Media & Performance", 
    description1: "Your ad spend should be an investment, not a gamble. We build precision-targeted campaigns that maximize returns and keep your brand front-of-mind where it matters most.", 
    description2: "From Google Ads to social campaigns, we optimize every stage of the funnel to deliver the best possible ROI while continually testing and refining your ads.", 
    services: ["Google Ads", "Facebook & Instagram Ads", "LinkedIn Campaigns", "Retargeting", "Performance Optimization"],
    link: "/digital-marketing/services/paid-media-performance"
  },
  { 
    title: "Analytics & Insights", 
    description1: "Numbers tell a story, if you know how to read them. We turn raw data into powerful insights that guide smarter strategies and sharper decision-making.", 
    description2: "We’ll help you understand exactly what’s working, what’s not, and where the biggest opportunities lie, so your marketing budget works harder for you.", 
    services: ["Google Analytics Setup", "Custom Dashboards", "Campaign Tracking", "Conversion Rate Optimization", "Reporting & Insights"],
    link: "/digital-marketing/services/analytics-insights"
  }
];


 
const AboutSection = () => {
  
   const serviceSlug = useMemo(() => {
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    return pathParts[pathParts.length - 1]; // "content-creative"
  }, []);

   const service = servicesData.find(s => s.link.endsWith(serviceSlug));


   const [isTextInView, setTextInView] = useState(false);

  const description = useRef(null);
 
  

  const servicesRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const descriptionRect = description.current.getBoundingClientRect();
      setTextInView(descriptionRect.top < window.innerHeight / 1.15);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");

    const scrollReveal = () => {
      for (let i = 0; i < revealElements.length; i++) {
        const elementIsInScreen = revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;

        if (elementIsInScreen) {
          revealElements[i].classList.add("revealed");
        } else {
          revealElements[i].classList.remove("revealed");
        }
      }
    };

    window.addEventListener("scroll", scrollReveal);
    scrollReveal(); // Initial check

    return () => {
      window.removeEventListener("scroll", scrollReveal);
    };
  }, []);


  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
        } else {
          entry.target.classList.remove('revealed');
        }
      });
    },
    { threshold: 0.1 }
  );

  const spans = document.querySelectorAll('span[data-animate-text]');
  spans.forEach(span => observer.observe(span));

  return () => {
    spans.forEach(span => observer.unobserve(span));
  };
}, []);


  return (
    <>
      <div className="about-container" ref={description}>
    

        <div className="about-desc-1">
          <h1 className="about__title">
            <span data-animate-text>
            &#123; What you can expect from us: &#125;
            </span>
          </h1>
          <p className="description1">
            <span data-animate-text>
              {service.description1}
             </span>
          </p>
        </div>

        <div className="about-desc-2" ref={servicesRef}>
          <div className="services-element">
            <h1>All Services</h1>
          <ul>
            {service.services?.map((srv, idx) => (
              <li key={idx} data-reveal>
                <TiTick /> {srv}
              </li>
            ))}
          </ul>
          </div>
          <div className="about-element">
           <p className="description2">
              <span data-animate-text>
            {service.description2}
                </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutSection;
